import script from "./AppDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppDialog.vue?vue&type=script&setup=true&lang=ts"

import "./AppDialog.vue?vue&type=style&index=0&id=0eaac0a9&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2158973318/src/pricing_engine_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eaac0a9"]])

export default __exports__